import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";

import PageHeader from "../../../../app/layout/PageHeader";
import { api } from "../../../../api/apiClient";
import { ServiceRegistrationMemberTypeStatic } from "../../../types/types";

import "../../../../css/buttons.css";
import "../../../../css/cards.css";

interface ServiceMembersTabProps {
  tenantId: number;
  serviceId: number | null;
  onBack: () => void;
}

export default function ServiceMembersTab({
  tenantId,
  serviceId,
  onBack,
}: ServiceMembersTabProps) {
  const history = useHistory();

  const registerServiceUser = async () => {
    if (!serviceId) return;

    const memberTypes = await api<ServiceRegistrationMemberTypeStatic[]>(
      `/api/services/${serviceId}/registration-requirements/member-types`,
    );
    const partyType =
      memberTypes.find((memberType) => memberType.code === "ServiceUser")
        ?.partyType ?? "Family";
    history.push(
      `/manage-party?serviceId=${serviceId}&memberType=ServiceUser&partyType=${partyType}&source=ServiceMembers`,
    );
  };

  return (
    <>
      <PageHeader
        title="Service Members"
        subtitle="Review and manage parties enrolled in this service."
        actions={
          <button
            type="button"
            className="icon-button-solid"
            onClick={onBack}
            title="Back to services"
            aria-label="Back to services"
          >
            <ArrowBackIcon fontSize="small" />
          </button>
        }
      />

      <div className="card">
        <div className="field-hint">
          Service member management will use service enrollment data.
          {serviceId ? ` Service ID: ${serviceId}.` : ""}
          {tenantId ? ` Tenant ID: ${tenantId}.` : ""}
        </div>
        {serviceId && (
          <div className="button-row button-row-left" style={{ marginTop: 16 }}>
            <button
              type="button"
              className="action-button"
              onClick={() => history.push(`/services/${serviceId}/members`)}
            >
              Open Service Members
            </button>
            <button
              type="button"
              className="action-button secondary"
              onClick={registerServiceUser}
            >
              Register service user
            </button>
          </div>
        )}
      </div>
    </>
  );
}
